import { ca } from '@cian/analytics';

export const trackShowMessage = (chatId: string, messageId: string, offerId?: number, communicationId?: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Show_sopr',
    label: 'Messages',
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: communicationId,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export const trackClickMessage = (
  chatId: string,
  messageId: string,
  messageType: string,
  offerId?: number,
  communicationId?: string,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'Messages',
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: communicationId,
        message_type: messageType,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};
